export { default } from "./CardFooter";
